import React from 'react';

interface WPMLogoProps {
  size?: number;
}

const WPMLogo: React.FC<WPMLogoProps> = ({ size = 36 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="wpm-grad" x1="0" y1="0" x2="44" y2="44" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#7c3aed" />
        <stop offset="100%" stopColor="#2563eb" />
      </linearGradient>
    </defs>
    <rect width="44" height="44" rx="10" fill="url(#wpm-grad)" />
    <path
      d="M 8 13 L 15 31 L 22 20 L 29 31 L 36 13"
      stroke="white"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="8" y1="36" x2="36" y2="36"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeOpacity="0.35"
    />
  </svg>
);

export default WPMLogo;
